import * as svg from "../../../assets/award-icon.svg";

import {iconBuilder} from "./iconBuilder";

const AwardIcon = iconBuilder(svg, "AwardIcon", "0 0 13 13");

export default AwardIcon;
